var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoopCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7161 2.999C7.47446 2.88234 3.99946 6.29067 3.99946 10.499H2.50779C2.13279 10.499 1.94946 10.949 2.21612 11.2073L4.54112 13.5407C4.70779 13.7073 4.96612 13.7073 5.13279 13.5407L7.45779 11.2073C7.51537 11.1486 7.55428 11.0741 7.56961 10.9933C7.58493 10.9125 7.57599 10.8289 7.54391 10.7532C7.51183 10.6774 7.45804 10.6129 7.38933 10.5676C7.32061 10.5224 7.24005 10.4985 7.15779 10.499H5.66612C5.66612 7.249 8.31612 4.624 11.5828 4.66567C14.6828 4.70734 17.2911 7.31567 17.3328 10.4157C17.3745 13.674 14.7495 16.3323 11.4995 16.3323C10.1578 16.3323 8.91612 15.874 7.93279 15.099C7.77317 14.9733 7.57291 14.9106 7.37009 14.9229C7.16728 14.9352 6.97605 15.0216 6.83279 15.1657C6.48279 15.5157 6.50779 16.1073 6.89946 16.4073C8.20873 17.4427 9.83026 18.0038 11.4995 17.999C15.7078 17.999 19.1161 14.524 18.9995 10.2823C18.8911 6.374 15.6245 3.10734 11.7161 2.999ZM11.2911 7.16567C10.9495 7.16567 10.6661 7.449 10.6661 7.79067V10.8573C10.6661 11.149 10.8245 11.424 11.0745 11.574L13.6745 13.1157C13.9745 13.2907 14.3578 13.1907 14.5328 12.899C14.7078 12.599 14.6078 12.2157 14.3161 12.0407L11.9161 10.6157V7.78234C11.9161 7.449 11.6328 7.16567 11.2911 7.16567Z",
    fill: "#1969CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopCircle);
export default __webpack_public_path__ + "static/media/loop_circle.e0f389417f55fd5b3df1be715fa98dcf.svg";
export { ForwardRef as ReactComponent };